export const vaccinationQueryKeys = {
  all: () => "vaccination"
};
